(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lw-ai-disclosure"] && !Shopify.designMode) return;
  try {
    function exposeAiCaptions(root = document) {
    root.querySelectorAll('.lw-ai-image').forEach((figure) => {
      const container = figure.closest('.card__image[aria-hidden="true"], .card__image--background[aria-hidden="true"], .rich-text__image[aria-hidden="true"]');
      if (container) container.removeAttribute('aria-hidden');
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => exposeAiCaptions(), { once: true });
  } else {
    exposeAiCaptions();
  }
  document.addEventListener('shopify:section:load', (event) => exposeAiCaptions(event.target));
  } catch(e) { console.error(e); }
})();

})();
